const component = "edit-site-details-drawer";

export const editSiteDetailsDrawer = {
  component,
  title: `${component}/title`,
  subtitle: `${component}/subtitle`,
  saveButton: `${component}/save-button`,
  cancelButton: `${component}/cancel-button`,
};
